export enum HTTPCodes {
  FORBIDDEN = 403,
  UNAUTHORIZED = 401
}
